import { render, staticRenderFns } from "./courseWidge.vue?vue&type=template&id=a8965c22&scoped=true"
import script from "./courseWidge.vue?vue&type=script&lang=js"
export * from "./courseWidge.vue?vue&type=script&lang=js"
import style0 from "./courseWidge.vue?vue&type=style&index=0&id=a8965c22&prod&lang=scss&scoped=true"
import style1 from "./courseWidge.vue?vue&type=style&index=1&id=a8965c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8965c22",
  null
  
)

export default component.exports